import React, { HTMLAttributes } from 'react';
import './index.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import wasistwasIcon from './images/wasistwas_icon.jpg';
import ravensburgerIcon from './images/ravensburger_icon.png';
import antolinIcon from './images/antolin_icon.jpg';
import lunaIcon from './images/luna_16.png';
import moleskineIcon from './images/moleskine_icon.png';
import puzzleIcon from './images/puzzle_icon.png';
import playstationIcon from './images/playstation_icon.png';

import xboxIcon from './images/xbox_icon.png';
import nintendoIcon from './images/nintendo_switch_icon.png';
import legoIcon from './images/lego_icon.png';
import playmobilIcon from './images/playmobil_icon.png';
import sikuIcon from './images/siku_icon.png';

import menuJson from './Menu.json';
import { replaceAllComplex } from '../../../../../../mol_function';
import { Link } from 'react-router-dom';
import {
  browserUrlToReactUrl,
  reactUrlToBrowserUrl,
} from '../../../../../../urlParse';
import MolLink from './MolLink';
import { MobileMenuItem } from './MobileMenuItem';
import { startPopup, endPopup } from '../../index';

interface MenuItem {
  Name: string;
  URL: string;

  AllName?: string;
  debug?: boolean;

  Image?: string;
  Title?: string;

  Class?: string;
  items?: MenuItem[];
}

interface MenuState {
  isMobileOpen: boolean;
  currentTree: MenuItem[];
  currentKey: string;
  currentTopic: string;
}

interface MenuProps {
  domainPrefix: string;
  isMobil: boolean;
}

export default class MenuObj extends React.Component<MenuProps, MenuState> {
  menuObject: MenuItem[];

  /**
   *
   */
  constructor(props: any) {
    super(props);

    let tmp = menuJson;

    this.menuObject = JSON.parse(
      replaceAllComplex(JSON.stringify(tmp), [
        { s: '%CALENDAR_NEXT_YEAR%', r: '2022' },
      ]),
    );
    this.state = {
      isMobileOpen: false,
      currentKey: 'dropMB',
      currentTree: this.menuObject,
      currentTopic: 'Menu',
    };
  }

  openPopup() {
    this.setState({ isMobileOpen: true });
    startPopup();
  }

  closePopup() {
    this.mobileMenuHadler('dropMB_0_0');
    this.setState({ isMobileOpen: false });
    endPopup();
  }

  mobileMenuHadler(key) {
    let splitKey = key.substr(7).split('_');

    let newTitle = 'Menu';
    let newKey = 'dropMB';

    let newTree = [];

    let newitem: any = [];
    if (splitKey.length > 1 && splitKey[splitKey.length - 1] == '0') {
      //Back
      splitKey.pop();
      splitKey.pop();
    }
    if (splitKey.length > 0) {
      for (let i = 0; i < splitKey.length; i++) {
        if (i == 0) {
          let menuBackup = this.menuObject;
          newitem = menuBackup[splitKey[0]];
          newTitle = newitem.Name;
          newKey = newKey + '_' + splitKey[0];
        } else {
          //-2 => Back + All
          let index = splitKey[i] - 2;
          newitem = newitem.items[index];
          newTitle = newitem.Name;
          newKey = newKey + '_' + splitKey[index];
        }
      }

      let allItem = null;

      if (newitem.AllName != undefined) {
        allItem = {
          Name: newitem.AllName,
          URL: newitem.URL,
          Class: 'mobilemenu',
        };
      }

      //remove allItem
      if (newitem.items[0].Class == 'mobilemenu') {
        if (allItem == null) allItem = newitem.items[0];
        newitem.items.shift();
      }

      //add all follback
      if (allItem == null) {
        allItem = {
          Name: 'Alle ' + newitem.Name,
          URL: newitem.URL,
          Class: 'mobilemenu',
        };
      }

      //add back
      let back: MenuItem = { Name: 'Zurück', URL: '', Class: 'menuBack' };

      newTree = [back, allItem].concat(newitem.items);
    } else {
      newTree = this.menuObject;
    }
    this.setState({
      currentTree: newTree,
      currentKey: newKey,
      currentTopic: newTitle,
    });
  }

  render() {
    let icons = {
      'images/wasistwas_icon.jpg': wasistwasIcon,
      'images/ravensburger_icon.png': ravensburgerIcon,
      'images/banners/antolin_icon.jpg': antolinIcon,
      'images/luna_16.png': lunaIcon,
      'images/moleskine_icon.png': moleskineIcon,
      'images/puzzle_icon.png': puzzleIcon,
      'images/playstation_icon.png': playstationIcon,
      'images/xbox_icon.png': xboxIcon,
      'images/nintendo_switch_icon.png': nintendoIcon,
      'images/lego_icon.png': legoIcon,
      'images/playmobil_icon.png': playmobilIcon,
      'images/siku_icon.png': sikuIcon,
    };

    if (this.props.isMobil) {
      if (!this.state.isMobileOpen) {
        return (
          <div
            onClick={() => {
              this.openPopup();
            }}
          >
            <FontAwesomeIcon
              icon={faBars}
              style={{
                marginLeft: '10px',
                marginTop: '20px',
                fontSize: '24px',
                width: '21px',
                height: '24px',
              }}
            />
          </div>
        );
      } else {
        //let currentTree = this.menuObject;
        //let currentKey = 'dropMB-';

        let currentTree = this.state.currentTree;
        let currentKey = this.state.currentKey;

        let currentTopic = this.state.currentTopic;

        return (
          <div className="popUp">
            <h2 title="Menu">
              {currentTopic}
              <FontAwesomeIcon
                icon={faBars}
                style={{
                  fontSize: '24px',
                  float: 'right',
                }}
                onClick={() => {
                  this.closePopup();
                }}
              />
            </h2>
            <div>
              {renderMenuRecusivStatic(
                currentTree,
                currentKey,
                0,
                true,
                this.props.domainPrefix,
                icons,
                (key) => {
                  this.mobileMenuHadler(key);
                },
                () => {
                  this.closePopup();
                },
              )}
            </div>
          </div>
        );
      }
      /*
      return (
        <nav id="mobileMenu">
          <h2 title="Menu">
            <i>
              <i className="fa fa-bars"></i>
            </i>
            Menu
          </h2>
          <ul className="menu">
            {this.renderMenuRecusiv(this.menuObject, 'dropMB-', 0, true)}
          </ul>
        </nav>
      );*/
    } else
      return (
        <React.Fragment>
          <div id="menuStartPoint">
            <nav id="dynamicMenu">
              <label htmlFor="drop" className="toggle">
                <span className="menu_txt">&#9776; &nbsp; Menu</span>
              </label>
              <input type="checkbox" id="drop" />
              <ul className="menu">
                <li className="mainItem" id="compactMenu">
                  <label htmlFor="dropCP" className="toggle"></label>
                  <a>&#9776; &nbsp; Menu </a>
                  <input type="checkbox" id="dropCP" />
                  <ul className="menu">
                    {renderMenuRecusivStatic(
                      this.menuObject,
                      'dropCP-',
                      1,
                      false,
                      this.props.domainPrefix,
                      icons,
                      this.mobileMenuHadler,
                      this.closePopup,
                    )}
                  </ul>
                </li>
                {renderMenuRecusivStatic(
                  this.menuObject,
                  'drop-',
                  0,
                  false,
                  this.props.domainPrefix,
                  icons,
                  this.mobileMenuHadler,
                  this.closePopup,
                )}
              </ul>
            </nav>
          </div>
        </React.Fragment>
      );
  }
}
export function renderMenuRecusivStatic(
  items: MenuItem[],
  prefixName: string,
  level: number,
  mobileMenu: boolean,
  domainPrefix: string,
  icons: any,
  clickHandler: (key: string) => void,
  closeHandler: () => void,
): JSX.Element {
  let keys = Object.keys(icons);

  return (
    <React.Fragment>
      {items.map((item, index) => {
        let dynamicParams: HTMLAttributes<HTMLLIElement> = {};
        if (item.Class !== undefined) dynamicParams.className = item.Class;
        let imageItem = null;
        let imageSrc = undefined;
        if (item.Image != null) {
          if (keys.indexOf(item.Image) > -1) {
            imageSrc = icons[item.Image];
          } else {
            debugger;
            imageSrc = domainPrefix + '/' + item.Image;
          }

          imageItem = <img src={imageSrc} />;
        }
        let urlToTransform = null;
        let reactLink = '';
        let molHref = null;

        if (item.debug != undefined) {
          debugger;
        }

        try {
          urlToTransform = decodeURI(item.URL);
        } catch {}

        if (urlToTransform != null) {
          reactLink = browserUrlToReactUrl(urlToTransform, null);
          if (reactLink != '') {
            let newUrl = reactUrlToBrowserUrl(reactLink, null, null);

            molHref = newUrl.substr(1);
          }
        }

        if (!mobileMenu) {
          return (
            <li {...dynamicParams} key={prefixName + index}>
              {item.items != undefined && (
                <label className="toggle" htmlFor={prefixName + index}>
                  {item.Name + ' '}
                  {level === 0 && <span color="#c0c0c0">▾</span>}
                </label>
              )}
              {reactLink != '' ? (
                <MolLink
                  href={domainPrefix + '/' + molHref}
                  to={reactLink}
                  title={item.Title}
                  orgHref={item.URL}
                >
                  {imageItem && imageItem}
                  {item.Name + ' '}
                  {level === 0 && <span color="#c0c0c0">▾</span>}
                </MolLink>
              ) : (
                <a href={domainPrefix + '/' + item.URL} title={item.Title}>
                  {imageItem && imageItem}
                  {item.Name + ' '}
                  {level === 0 && <span color="#c0c0c0">▾</span>}
                </a>
              )}

              {item.items != undefined && (
                <React.Fragment>
                  <input type="checkbox" id={prefixName + index} />
                  <ul>
                    {renderMenuRecusivStatic(
                      item.items,
                      prefixName + index + '_',
                      level + 1,
                      mobileMenu,
                      domainPrefix,
                      icons,
                      clickHandler,
                      closeHandler,
                    )}
                  </ul>
                </React.Fragment>
              )}
            </li>
          );
        } else {
          return (
            <MobileMenuItem
              key={prefixName + '_' + index}
              itemKey={prefixName + '_' + index}
              name={item.Name}
              clickHandler={clickHandler}
              hasChildren={
                (item.items != undefined && item.items.length > 0) ||
                item.Class == 'menuBack'
              }
              itemClass={item.Class}
              extern={reactLink == ''}
              hreff={reactLink != '' ? reactLink : item.URL}
              closeEvent={() => {
                closeHandler();
              }}
              image={imageSrc}
            />
          );
        }
      })}
    </React.Fragment>
  );
}
